import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import AppBar from '@material-ui/core/AppBar';
import { LandingPage } from './pages/landing-page';
import { AddPlayers } from './pages/add-players';
import { RoundDetails } from './pages/round-details';
import { CompletePage } from './pages/complete';
import { TitleCreator } from './components/titleCreator';

export default props => {

	return (
		<Router>
			<AppBar position="fixed">
				<TitleCreator></TitleCreator>
			</AppBar>
			<div className="App">
				<Switch>
					<Route exact path="/" component={LandingPage} />
					<Route exact path="/add-players" component={AddPlayers} />
					<Route exact path="/round-details" component={RoundDetails} />
					<Route exact path="/complete" component={CompletePage} />
					<Route component={LandingPage} />
				</Switch>
			</div>
		</Router>
	);
};
